import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { AdPopupSurface } from '@entities/ad-popup';
import { api } from '@shared/api';

import { adPopupRuntimeKeys, currentAdPopupQuery } from './queries';

export function useCurrentAdPopup(surface: AdPopupSurface, enabled = true) {
  return useQuery(currentAdPopupQuery(surface, enabled));
}

export function useDismissAdPopup() {
  const queryClient = useQueryClient();
  return useMutation<undefined, Error, { id: string; requestId: string }>({
    mutationFn: async ({ id, ...body }) => {
      await api.post<undefined, typeof body>(`/api/v1/ad-popups/${id}/dismiss`, body, {
        keepalive: true,
      });
      return undefined;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: adPopupRuntimeKeys.all });
    },
  });
}
